import React, { useEffect, useState } from "react";

const TablePilgrimageTripsSchedule = (props) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(`https://elgalatours-api.herokuapp.com/${props.urlApi}`)
      .then((res) => res.json())
      .then((data) => setItems(data));
  });

  return (
    <tbody>
      {items.map((item) => (
        <tr key={item.id}>
          <td>{item.sea}</td>
          <td>{item.wild}</td>
          <td>{item.airline}</td>
          <td>{item.numberOfNights}</td>
          <td>{item.cityHotels}</td>
          <td>{item.city}</td>
          <td>{item.meccaHotels}</td>
          <td>{item.mecca}</td>
          <td>{item.level}</td>
          <th scope="row">{item.id}</th>
        </tr>
      ))}
    </tbody>
  );
};

export default TablePilgrimageTripsSchedule;
